<template>
  <section class="body">
    <div class="content">
      <div class="institution">
        <InstitutionBadge
          :institution="
            getInstitutionsNames(transcription.source as InstitutionKey)
          "
        />
        <span class="title-medium-light">
          {{
            getInstitutionsNames(transcription.source as InstitutionKey)
          }}</span
        >
      </div>
      <div class="title title-large-semibold">
        {{ transcription.title }}
      </div>
    </div>
  </section>
  <section v-if="listOfWords" class="footer">
    <span class="title-medium-regular" data-testid="matched words">
      <span class="matched-words">Mots matchés</span> : {{ listOfWords }}
    </span>
  </section>
</template>

<script setup lang="ts">
import { computed } from "vue";
import InstitutionBadge from "../../legi-work/atoms/InstitutionBadge.vue";
import {
  getInstitutionsNames,
  type InstitutionKey,
} from "@/follaw-fr/utils/institutions.utils";
import type { TranscriptionEsOutputZoom } from "@/commons/types/api/schema.types";

type TranscriptionCardContentProps = {
  transcription: TranscriptionEsOutputZoom;
};
const { transcription } = defineProps<TranscriptionCardContentProps>();

const listOfWords = computed(
  () => transcription.matched_words?.slice(0, 10).join(", ") || ""
);
</script>

<style lang="scss" scoped>
.body {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: 8px;
  .institution {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 12px;
  }

  .title {
    padding: 10px;
  }
}

.footer {
  display: flex;
  align-items: center;
  gap: 8px;

  .matched-words {
    color: var(--clr-s7);
  }
}
</style>
